import React from "react";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Button } from "bootstrap";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.vfs;

export default function DownLossdbillingPDF({ data }) {


    console.log('Full data :', data);


    // const downloadBillingPDF = () => {

    //     // ── SMART NUMBER FORMAT ──
    //     // Shows decimals only when needed: 1000 → "1000", 95.5 → "95.50"
    //     const fmtNum = (val) => {
    //         const n = parseFloat(String(val || 0).replace(/,/g, "")) || 0;
    //         return Number.isInteger(n) ? String(n) : n.toFixed(2);
    //     };

    //     const parseAmount = (val) => {
    //         if (!val) return 0;
    //         return parseFloat(String(val).replace(/,/g, "")) || 0;
    //     };

    //     // ── HEIGHT ESTIMATE ──
    //     const estimateHeight = () => {
    //         let h = 12;
    //         h += Math.ceil((data?.vendor_company_name || "").length / 30) * 5;
    //         h += Math.ceil((data?.vendor_address || "").length / 35) * 4;
    //         h += 6 + 5;        // phone + solidLine
    //         h += 6 + 6;        // order id + date
    //         if (data?.meal_time_lable) h += 6;
    //         h += 5;            // solidLine

    //         const offerType = data?.applied_card_detail?.offer_type;
    //         if (offerType != "3") {
    //             h += 8 + (data?.order_item?.length || 1) * 10;
    //         }
    //         if (parseFloat(data?.discount_amount || 0) > 0) h += 18;

    //         if (offerType == "3") {
    //             const buyCount = data?.offer_details?.buy_products?.length || 0;
    //             const getCount = data?.offer_details?.get_products?.length || 0;
    //             h += 14 + 8 + buyCount * 10 + 6 + 12 + 6; // label+table+gap+total+gap
    //             h += 14 + 8 + getCount * 10 + 6 + 12 + 6;
    //         }

    //         h += 8;  // solidLine + subtotal
    //         if (parseFloat(data?.delivery_charge || data?.delivery_charges || 0) > 0) h += 6;
    //         if (parseFloat(data?.packing_charge || data?.packing_charges || 0) > 0) h += 6;
    //         if (parseFloat(data?.user_platform_charges || 0) > 0) h += 6;
    //         if (parseFloat(data?.delivery_tip || 0) > 0) h += 6;
    //         if (parseFloat(data?.gst_percentage || 0) > 0) h += 12;
    //         if (parseFloat(data?.round_off || 0) !== 0) h += 6;
    //         h += 6 + 6 + 6 + 10; // dashedLine + TOTAL + solidLine + footer

    //         return Math.max(h, 120);
    //     };

    //     const doc = new jsPDF({ unit: "mm", format: [80, estimateHeight()] });
    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     let y = 12;

    //     // ── SPACING CONSTANTS ──
    //     const SP = 6;   // standard row gap
    //     const SP_S = 4;   // small gap (after lines)

    //     const solidLine = () => {
    //         doc.setDrawColor(100);
    //         doc.setLineDash([], 0);
    //         doc.line(4, y, pageWidth - 4, y);
    //         y += SP_S;
    //     };

    //     const dashedLine = () => {
    //         doc.setDrawColor(170);
    //         doc.setLineDash([1, 1], 0);
    //         doc.line(4, y, pageWidth - 4, y);
    //         doc.setLineDash([], 0);
    //         y += SP_S;
    //     };

    //     const rowText = (left, right, size = 8, bold = false, color = [40, 40, 40]) => {
    //         doc.setFont("helvetica", bold ? "bold" : "normal");
    //         doc.setFontSize(size);
    //         doc.setTextColor(...color);
    //         doc.text(left != null ? String(left) : "", 4, y);
    //         doc.text(right != null ? String(right) : "", pageWidth - 4, y, { align: "right" });
    //         y += SP;
    //         doc.setTextColor(40, 40, 40);
    //     };

    //     const centerText = (text, size, bold = false) => {
    //         doc.setFont("helvetica", bold ? "bold" : "normal");
    //         doc.setFontSize(size);
    //         doc.setTextColor(40, 40, 40);
    //         doc.text(text ? String(text) : "", pageWidth / 2, y, { align: "center" });
    //         y += SP;
    //     }; 

    //     const makeTable = (startY, body) => {
    //         autoTable(doc, {
    //             startY,
    //             head: [["Item", "Quantity", "Rate", " Amount"]],
    //             body,
    //             theme: "plain",
    //             styles: {
    //                 fontSize: 7.5,
    //                 cellPadding: { top: 2.5, bottom: 2.5, left: 1, right: 1 },
    //                 textColor: [40, 40, 40],
    //                 valign: "middle",
    //                 overflow: "linebreak",
    //             },
    //             headStyles: {
    //                 fontStyle: "normal",
    //                 textColor: [60, 60, 60],
    //                 lineWidth: { bottom: 0.3 },
    //                 lineColor: [100, 100, 100],
    //             },
    //             columnStyles: {
    //                 0: { cellWidth: 30, halign: "left", font: "helvetica" },
    //                 1: { cellWidth: 14, halign: "center" },
    //                 2: { cellWidth: 12, halign: "right" },
    //                 3: { cellWidth: 16, halign: "right" },
    //             },
    //             margin: { left: 4, right: 4 },
    //         });
    //     };

    //     // ── HEADER ──
    //     const nameLines = doc.splitTextToSize(data?.vendor_company_name || "", pageWidth - 8);
    //     doc.setFont("helvetica", "bold"); doc.setFontSize(11);
    //     nameLines.forEach(l => { doc.text(l, pageWidth / 2, y, { align: "center" }); y += 5; });

    //     doc.setFont("helvetica", "normal"); doc.setFontSize(7.5);
    //     const addrLines = doc.splitTextToSize(data?.vendor_address || "", pageWidth - 8);
    //     addrLines.forEach(l => { doc.text(l, pageWidth / 2, y, { align: "center" }); y += 4; });

    //     centerText(`Phone: ${data?.vendor_mbl || ""}`, 7.5);
    //     solidLine();

    //     // ── ORDER INFO ──
    //     const orderDate = data?.order_date ? new Date(data.order_date).toLocaleString("en-IN") : "";
    //     y += 2;
    //     rowText(`Order ID : ${data?.order_id || ""}`, "");
    //     rowText(`Date     : ${orderDate}`, "");
    //     if (data?.meal_time_lable) rowText(`Meal     : ${data.meal_time_lable}`, "");
    //     solidLine();

    //     // ── ITEMS (non offer-3) ──
    //     const items = data?.order_item?.length ? data.order_item : [{
    //         item_name: data?.ticket?.ticket_name || "",
    //         item_quantity: data?.quantity_of_ticket || 1,
    //         item_price: data?.ticket_price || 0,
    //     }];

    //     if (data?.applied_card_detail?.offer_type != "3") {
    //         const body = items.map(item => {
    //             const qty = Number(item.item_quantity || 1);
    //             const price = parseAmount(item.item_price || 0);
    //             const amt = qty * price;
    //             return [item.item_name || "", String(qty), fmtNum(price), fmtNum(amt)];
    //         });
    //         makeTable(y, body);
    //         y = doc.lastAutoTable.finalY + SP_S;
    //     }

    //     // ── SAVED BY OFFER ──
    //     const discountAmount = parseAmount(data?.discount_amount || 0);
    //     if (discountAmount > 0) {
    //         solidLine();
    //         rowText(data?.Saved_by || "Saved by offer", ` ${fmtNum(discountAmount)}`, 8, false);
    //         solidLine();
    //     }

    //     // ── OFFER TYPE 3 ──
    //     const formatRow = (item) => {
    //         const name = item?.product_name ? String(item.product_name) : "-";
    //         const qty = parseAmount(item?.unit_quantity || item?.added_count || 1);
    //         const price = parseAmount(item?.price || item?.original_price || 0);
    //         const amt = qty * price;
    //         return [name, String(qty), fmtNum(price), fmtNum(amt)];
    //     };

    //     if (data?.applied_card_detail?.offer_type == "3") {
    //         const buyBody = (data?.offer_details?.buy_products || []).map(formatRow);
    //         const getBody = (data?.offer_details?.get_products || []).map(formatRow);

    //         // ── BUY PRODUCTS ──
    //         y += SP_S;
    //         rowText("Buy Products", "", 8.5, true);
    //         // y += 1;
    //         makeTable(y, buyBody);
    //         y = doc.lastAutoTable.finalY + SP_S;
    //         dashedLine();
    //         y += SP_S;

    //         rowText("Total (Offer Price)", `Rs. ${fmtNum(parseAmount(data?.offer_details?.buy_products_total))}`, 8, true);
    //         dashedLine();

    //         // ── GET PRODUCTS ──
    //         y += SP_S;
    //         rowText("Get Products (Free)", "", 8.5, true);
    //         // y += 1;
    //         makeTable(y, getBody);
    //         y = doc.lastAutoTable.finalY + SP_S;
    //         dashedLine();
    //         y += SP_S;

    //         rowText("Total (Free Value)", `Rs. ${fmtNum(parseAmount(data?.offer_details?.get_products_total))}`, 8, true);
    //         dashedLine();
    //     }

    //     // ── BILLING SUMMARY ──
    //     solidLine();
    //     const subTotal = parseAmount(data?.sub_total);
    //     const deliveryCharge = parseAmount(data?.delivery_charge || data?.delivery_charges);
    //     const packingCharge = parseAmount(data?.packing_charge || data?.packing_charges);
    //     const platformCharge = parseAmount(data?.user_platform_charges);
    //     const deliveryTip = parseAmount(data?.delivery_tip);
    //     const roundOff = parseFloat(data?.round_off || 0);
    //     const gstPct = parseFloat(data?.gst_percentage || 0);
    //     const halfGst = gstPct > 0 ? (subTotal * gstPct) / 100 / 2 : 0;

    //     rowText("Subtotal", `Rs ${fmtNum(subTotal)}`);
    //     if (deliveryCharge > 0) rowText("Delivery Charge", `  ${fmtNum(deliveryCharge)}`);
    //     if (packingCharge > 0) rowText("Packing Cost", `  ${fmtNum(packingCharge)}`);
    //     if (platformCharge > 0) rowText("Platform Charge", `  ${fmtNum(platformCharge)}`);
    //     if (deliveryTip > 0) rowText("Delivery Tip", ` ${fmtNum(deliveryTip)}`);
    //     if (gstPct > 0) {
    //         rowText(`SGST (${gstPct / 2}%)`, `${fmtNum(halfGst)}`);
    //         rowText(`CGST (${gstPct / 2}%)`, `${fmtNum(halfGst)}`);
    //     }
    //     if (roundOff !== 0) rowText("Round Off", ` ${fmtNum(roundOff)}`);

    //     solidLine();
    //     rowText("TOTAL", `Rs ${fmtNum(parseAmount(data?.total_amount))}`, 9, true);
    //     solidLine();

    //     doc.setTextColor(130, 130, 130);
    //     centerText("Thank you! Visit again", 7);

    //     doc.save(`Pingle_Receipt_${data?.order_id || "bill"}.pdf`);
    // };


    // ─────────────────────────────────────────────
    //  Billing PDF  –  uses pdfmake for layout
    //  Import in your project:
    //    import pdfMake from "pdfmake/build/pdfmake";
    //    import pdfFonts from "pdfmake/build/vfs_fonts";
    //    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    // ─────────────────────────────────────────────

    // ─────────────────────────────────────────────
    //  Billing PDF  –  pdfmake with native table borders
    //  Import in your project:
    //    import pdfMake from "pdfmake/build/pdfmake";
    //    import pdfFonts from "pdfmake/build/vfs_fonts";
    //    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    // ─────────────────────────────────────────────

    const downloadBillingPDF = () => {

        const PW = 226.77; // 80 mm in points
        const MARGIN = 11.34; // 4 mm in points
        const INNER = PW - MARGIN * 2; // usable width

        const fmtNum = (val) => {
            const n = parseFloat(String(val || 0).replace(/,/g, "")) || 0;
            return n.toFixed(2);
        };

        const parseAmount = (val) => {
            if (!val) return 0;
            return parseFloat(String(val).replace(/,/g, "")) || 0;
        };

        // ── Divider line using a 1-row borderless table with only a bottom border ──
        // This is the most reliable way to draw lines in pdfmake
        const makeLine = (color = "#444", dash = false) => ({
            table: {
                widths: [INNER],
                body: [[{ text: "", border: [false, false, false, true], borderColor: [color, color, color, color], margin: [0, 0, 0, 0] }]],
            },
            layout: dash
                ? {
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0,
                    hLineColor: () => color,
                    hLineStyle: () => ({ dash: { length: 2, space: 2 } }),
                }
                : {
                    hLineWidth: (i, node) => (i === node.table.body.length ? 0.5 : 0),
                    vLineWidth: () => 0,
                    hLineColor: () => color,
                },
            margin: [0, 3, 0, 3],
        });

        const LINE = makeLine("#444", false);
        const DLINE = makeLine("#aaa", true);

        // ── Item table using pdfmake native table for guaranteed border rendering ──
        const makeItemTable = (rows) => ({
            table: {
                widths: [100, 24, 32, "*"],
                headerRows: 1,
                body: [
                    // Header row
                    [
                        { text: "Item", fontSize: 7.5, bold: false, alignment: "left", margin: [0, 2, 0, 2] },
                        { text: "Qty.", fontSize: 7.5, bold: false, alignment: "center", margin: [0, 2, 0, 2] },
                        { text: "Price", fontSize: 7.5, bold: false, alignment: "right", margin: [0, 2, 0, 2] },
                        { text: "Amount", fontSize: 7.5, bold: false, alignment: "right", margin: [0, 2, 0, 2] },
                    ],
                    // Data rows
                    ...rows.map(([name, qty, price, amount]) => [
                        { text: String(name || ""), fontSize: 7.5, alignment: "left", margin: [0, 2.5, 0, 2.5] },
                        { text: String(qty || ""), fontSize: 7.5, alignment: "center", margin: [0, 2.5, 0, 2.5] },
                        { text: String(price || ""), fontSize: 7.5, alignment: "right", margin: [0, 2.5, 0, 2.5] },
                        { text: String(amount || ""), fontSize: 7.5, alignment: "right", margin: [0, 2.5, 0, 2.5] },
                    ]),
                ],
            },
            layout: {
                // Only draw the line under the header row
                hLineWidth: (i) => (i === 0 || i === 1) ? 0.4 : 0,
                vLineWidth: () => 0,
                hLineColor: () => "#555",
                paddingLeft: () => 0,
                paddingRight: () => 0,
                paddingTop: () => 0,
                paddingBottom: () => 0,
            },
            margin: [0, 2, 0, 2],
        });

        const txt = (text, opts = {}) => ({
            text: text != null ? String(text) : "",
            fontSize: opts.size || 7.5,
            bold: opts.bold || false,
            alignment: opts.align || "left",
            color: opts.color || "#1a1a1a",
            margin: opts.margin || [0, 0, 0, 0],
        });

        const center = (text, size = 7.5, bold = false, margin = [0, 1, 0, 1]) =>
            txt(text, { size, bold, align: "center", margin });

        const infoRow = (left, right, bold = false, size = 7.5) => ({
            columns: [
                { ...txt(left, { bold, size }), width: "*" },
                { ...txt(right, { bold, size, align: "right" }), width: "auto" },
            ],
            margin: [0, 1, 0, 1],
        });

        // ── Gather data ──
        const items = data?.order_item?.length ? data.order_item : [{
            item_name: data?.ticket?.ticket_name || "",
            item_quantity: data?.quantity_of_ticket || 1,
            item_price: data?.ticket_price || 0,
        }];

        const subTotal = parseAmount(data?.sub_total);
        const deliveryCharge = parseAmount(data?.delivery_charge || data?.delivery_charges);
        const packingCharge = parseAmount(data?.packing_charge || data?.packing_charges);
        const platformCharge = parseAmount(data?.user_platform_charges);
        const deliveryTip = parseAmount(data?.delivery_tip);
        const discountAmount = parseAmount(data?.discount_amount || 0);
        const roundOff = parseFloat(data?.round_off || 0);
        const gstPct = parseFloat(data?.gst_percentage || 0);
        const halfGst = gstPct > 0 ? (subTotal * gstPct) / 100 / 2 : 0;
        const totalQty = items.reduce((s, i) => s + Number(i.item_quantity || 1), 0);
        const offerType = data?.applied_card_detail?.offer_type;

        const orderDate = data?.order_date
            ? new Date(data.order_date).toLocaleDateString("en-IN", { day: "2-digit", month: "2-digit", year: "2-digit" })
            + "  " + new Date(data.order_date).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false })
            : "";

        const toRows = (list, isOffer = false) =>
            (list || []).map(item => {
                const name = isOffer ? (item?.product_name || "-") : (item.item_name || "");
                const qty = isOffer
                    ? parseAmount(item?.unit_quantity || item?.added_count || 1)
                    : Number(item.item_quantity || 1);
                const price = parseAmount(isOffer ? (Number(item?.price) || Number(item?.original_price) || 0) : (Number(item.item_price) || 0));
                const amt = qty * price;
                return [name, qty, fmtNum(price), fmtNum(amt)];
            });

        // ── Build content ──
        const content = [];

        content.push(center(data?.vendor_company_name || "", 11, true, [0, 1, 0, 2]));
        content.push(center(data?.vendor_address || "", 7.5, false, [0, 0, 0, 1]));
        content.push(center(`Phone : ${data?.vendor_mbl || ""}`, 7.5, false, [0, 0, 0, 2]));
        content.push(LINE);


        content.push(infoRow(`Order ID : ${data?.order_id || ""}`));
        content.push(infoRow(`Date: ${orderDate}`));


        if (data?.meal_time_lable)
            content.push(txt(`Meal: ${data.meal_time_lable}`, { margin: [0, 1, 0, 1] }));

        content.push(LINE);

        // Items
        if (offerType != "3") {
            content.push(makeItemTable(toRows(items)));
        } else {
            content.push(txt("Buy Products", { bold: true, size: 8.5, margin: [0, 2, 0, 2] }));
            content.push(makeItemTable(toRows(data?.offer_details?.buy_products, true)));
            content.push(DLINE);
            content.push({ text: "", margin: [2, 0, 0, 0] });
            content.push(infoRow("Total (Offer Price)", `Rs. ${fmtNum(parseAmount(data?.offer_details?.buy_products_total))}`, true));
            content.push(DLINE);
            content.push(txt("Get Products (Free)", { bold: true, size: 8.5, margin: [0, 4, 0, 2] }));
            content.push(makeItemTable(toRows(data?.offer_details?.get_products, true)));
            content.push(DLINE);
            content.push({ text: "", margin: [2, 0, 0, 0] });
            content.push(infoRow("Total (Free Value)", `Rs. ${fmtNum(parseAmount(data?.offer_details?.get_products_total))}`, true));
            content.push(DLINE);
        }

        // Sub total
        content.push(LINE);
        content.push(infoRow("Sub Total", fmtNum(subTotal)))

        if (gstPct > 0) {
            content.push(infoRow(`CGST ${gstPct / 2}%`, fmtNum(halfGst)));
            content.push(infoRow(`SGST ${gstPct / 2}%`, fmtNum(halfGst)));
        }
        if (deliveryCharge > 0) content.push(infoRow("Delivery Charge", fmtNum(deliveryCharge)));
        if (packingCharge > 0) content.push(infoRow("Packing Cost", fmtNum(packingCharge)));
        if (platformCharge > 0) content.push(infoRow("Platform Charge", fmtNum(platformCharge)));
        if (deliveryTip > 0) content.push(infoRow("Delivery Tip", fmtNum(deliveryTip)));
        if (discountAmount > 0) content.push(infoRow(data?.Saved_by || "Discount", `-${fmtNum(discountAmount)}`));
        if (roundOff !== 0) content.push(infoRow("Round off", `+${fmtNum(roundOff)}`));

        content.push(LINE);

        content.push({
            columns: [
                { text: "Grand Total", fontSize: 9, bold: true, width: "*" },
                {
                    text: `\u20B9${fmtNum(parseAmount(data?.total_amount))}`,
                    fontSize: 10, bold: true, alignment: "right", width: "auto"
                },
            ],
            margin: [2, 2, 0, 2],
        });

        content.push(LINE);

        content.push(center("Thank You!! Visit Us Again", 7, false, [0, 1, 0, 2]));

        const docDefinition = {
            pageSize: { width: PW, height: "auto" },
            pageMargins: [MARGIN, MARGIN, MARGIN, MARGIN],
            defaultStyle: {
                font: "Roboto",
                fontSize: 7.5,
                color: "#1a1a1a",
                lineHeight: 1.2,
            },
            content,
        };

        pdfMake.createPdf(docDefinition).download(`Receipt_${data?.order_id || "bill"}.pdf`);
    };

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button
                    onClick={() => downloadBillingPDF()}
                    style={{
                        display: 'flex', alignItems: 'center', gap: 4,
                        background: '#5B21B6', border: 'none', borderRadius: 6,
                        padding: '4px 10px', cursor: 'pointer',
                        color: '#fff', fontSize: 10, fontWeight: 500,
                    }}
                    className="ff-poppins-semiBold"
                >

                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                        stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                    Bill
                </button>

            </div>

        </>
    )
}

